import { useEffect } from 'react';

import { diagnostics } from '@/utils/diagnostics';

import { useGetRecipientNodeLazyQuery } from '../graphql/GetRecipientNode.generated';

interface UseRecipientDisplayNameResult {
  displayName: string | null;
  loading: boolean;
}

export function useRecipientDisplayName(
  recipientId: string | null
): UseRecipientDisplayNameResult {
  const [getRecipientNode, { data, loading }] = useGetRecipientNodeLazyQuery({
    onError(error) {
      diagnostics.error('Failed to get recipient display name', error);
    },
  });

  useEffect(() => {
    if (recipientId) {
      getRecipientNode({ variables: { id: recipientId } });
    }
  }, [recipientId, getRecipientNode]);

  let displayName: string | null = null;

  if (data?.node) {
    const node = data.node;
    if (node.__typename === 'ClientProfile') {
      displayName = node.displayName;
    } else if (node.__typename === 'Entity') {
      displayName = node.subtype?.displayName;
    } else if (node.__typename === 'TestamentaryEntity') {
      displayName = node.displayName;
    } else if (node.__typename === 'ClientOrganization') {
      displayName = node.name;
    }
  }

  return {
    displayName,
    loading,
  };
}
